module.exports = __webpack_public_path__ + "static/media/clydeEdnaMeet42.6eb9c459.png";